import { SESSION_FEATURES_KEY } from 'src/Hooks/useSessionFeature'

export const getSessionFeatures = () => sessionStorage.getItem(SESSION_FEATURES_KEY)?.split(',') || []
